export default {"src":"/_next/static/media/logo.c6743072.svg","height":25,"width":81};